import { createContext } from "react";
import { Asset } from "src/types/assets";

import {
  DealRoomAction,
  DealRoomActionEditChanges,
  DealRoomActionEditSliderChanges,
  DealRoomMapState,
  DealRoomRecipient,
} from "src/types/dealRoom";

import { dealRoomMapInitialState } from "src/utils/dealRoom.helper";

export interface DealRoomActionPlanContextProps {
  state: DealRoomMapState;
  handleTitleChange: (newValue: string) => void;
  handleCreateNewStage: () => void;
  handleCancelCreateNewStage: () => void;
  handleDeleteStage: (stageId: string) => void;
  handleFetchActions: (stageId: string, page: number) => void;
  handleEditAction: (
    changes: DealRoomActionEditChanges,
    stageId: string,
    actionId: string,
    isNewAction: boolean,
  ) => void;
  handleSaveAction: (
    action: DealRoomAction,
    stageId: string,
    isNewAction: boolean,
  ) => void;
  handleReorderAction: (
    newActionsOrder: DealRoomAction[],
    stageId: string,
  ) => void;
  toggleEditAction: (stageId: string, actionId: string, completed: boolean) => void;
  handleToggleEditStage: (stageId: string) => void;
  handleCancelEditStage: () => void;
  handleEditStage: (stageId: string, newTitle: string) => void;
  handleUpdateStage: (stageId: string) => void;
  handleCancelEditAction: (
    action: DealRoomAction,
    isNewAction: boolean,
  ) => void;
  handleSelectRecipient: (
    stageId: string,
    actionId: string,
    isNewAction: boolean,
    recipient: DealRoomRecipient,
    isAdded: boolean,
  ) => void;
  handleFetchRecipients: (dealRoomId: string, page: number) => void;
  handleFetchAssets: (dealRoomId: string, page: number) => void;
  clickCompleteAction: (
    stageId: string,
    actionId: string,
    completed: boolean,
  ) => void;
  toggleAddAssetsSlider: (
    showSlider: boolean,
    stageId: string,
    actionId: string,
    isNewAction?: boolean,
    exisingAction?: Asset[],
  ) => void;
  handleCompleteAction: (
    stageId: string,
    actionId: string,
    completed: boolean
  ) => void;
  clickDeleteStage: (
    stageId: string,
  ) => void;
  clickSaveAction: (
      action: DealRoomAction,
      stageId: string,
      changes: DealRoomActionEditSliderChanges,
    ) => void;
  clickDeleteAction: (
    action: DealRoomAction,
    stageId: string,
  ) => void;
  handleStageAccordionToggle: (stageId: string) => void;
}

export const DealRoomActionPlanContext =
  createContext<DealRoomActionPlanContextProps>({
    state: dealRoomMapInitialState,
    handleTitleChange: (newValue: string) => {},
    handleCreateNewStage: () => {},
    handleCancelCreateNewStage: () => {},
    handleDeleteStage: (stageId: string) => {},
    handleFetchActions: (stageId: string, page: number) => {},
    handleEditAction: (
      changes: DealRoomActionEditChanges,
      stageId: string,
      actionId: string,
      isNewAction: boolean,
    ) => {},
    handleSaveAction: (
      action: DealRoomAction,
      stageId: string,
      isNewAction: boolean,
    ) => {},
    handleReorderAction: (
      newActionsOrder: DealRoomAction[],
      stageId: string,
    ) => {},
    toggleEditAction: (stageId: string, actionId: string, completed: boolean) => {},
    handleToggleEditStage: (stageId: string) => {},
    handleCancelEditStage: () => {},
    handleEditStage: (stageId: string, newTitle: string) => {},
    handleUpdateStage: (stageId: string) => {},
    handleCancelEditAction: (
      action: DealRoomAction,
      isNewAction: boolean,
    ) => {},
    handleSelectRecipient: (
      stageId: string,
      actionId: string,
      isNewAction: boolean,
      recipient: DealRoomRecipient,
      isAdded: boolean,
    ) => {},
    handleFetchRecipients: (dealRoomId: string, page: number) => {},
    handleFetchAssets: (dealRoomId: string, page: number) => {},
    clickCompleteAction: (
      stageId: string,
      actionId: string,
      completed: boolean,
    ) => {},
    toggleAddAssetsSlider: (
      showSlider: boolean,
      stageId: string,
      actionId: string,
      isNewAction?: boolean,
      exisingAction?: Asset[],
    ) => {},
    handleCompleteAction: (
      stageId: string,
      actionId: string,
      completed: boolean
    ) => {},
    clickDeleteStage: (
      stageId: string,
    ) => {},
    clickSaveAction: (
      action: DealRoomAction,
      stageId: string,
      changes: DealRoomActionEditSliderChanges,
    ) => {},
    clickDeleteAction: (
      action: DealRoomAction,
      stageId: string,
    ) => {},
    handleStageAccordionToggle: (stageId: string) => {},
  });
